// @react
import React, { useState } from 'react'
// @common
import Cookies from 'universal-cookie'
// @types
import {
  GetFeaturedContentQuery,
  GetFeaturedContentQueryVariables,
} from 'lib/graphql/graphqlTypes'
// @graphql
import { useQuery } from '@apollo/client'
import { GET_FEATURED_CONTENT } from 'graphql/queries/featuredContent.query'
// @components
import Box from '@bit/atd.web.box'
import ContentCard from 'modules/common/components/ContentCard'
import QueryError from 'modules/common/components/Errors/QueryError'
import Spacer from '@bit/atd.web.spacer'
import Button from '@bit/atd.web.button'
import { addDays } from 'date-fns'
import { Grow } from '@material-ui/core'

/**
 * 2.0.0.6 MyATD - Dashboard - Featured Content
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=866%3A3045
 *
 * endpoint: algolia/featuredContent
 * response: GeneralContentDTO
 * response namespaces:
 *
 */
const cookies = new Cookies()
const FeaturedContent = () => {
  const COOKIES_NAME = 'hideFeatured'
  const cookieState = cookies.get(COOKIES_NAME)

  /******************************************
   * STATES
   ******************************************/
  const [showFeatured, setShowFeatured] = useState(true)

  /******************************************
   * GQL HOOKS
   ******************************************/

  const { loading: isLoading, error: isError, data } = useQuery<
    GetFeaturedContentQuery,
    GetFeaturedContentQueryVariables
  >(GET_FEATURED_CONTENT, {
    variables: {
      input: {
        page: 0,
        pageSize: 10,
      },
    },
  })

  /******************************************
   * FUNCTIONS
   ******************************************/
  const hideFeaturedHandler = () => {
    setShowFeatured(false)
  }

  const setCookie = () => {
    cookies.set(COOKIES_NAME, {
      path: '/',
      expires: addDays(new Date(), 1),
    })
  }

  /******************************************
   * RENDER
   ******************************************/

  if (cookieState) {
    return <></>
  }

  if (isLoading) {
    return <span>Loading...</span>
  }
  if (isError || !data) {
    return <QueryError />
  }

  return (
    <Grow
      in={showFeatured}
      timeout={showFeatured ? 0 : 500}
      unmountOnExit
      onExited={setCookie}
    >
      <div>
        <Box
          variant={'transparent'}
          header={{
            title: 'Featured today',
            actions: (
              <Button
                size={'small'}
                variant="secondary"
                onClick={hideFeaturedHandler}
              >
                <span>Hide</span>
              </Button>
            ),
            actionsAlignment: 'right',
          }}
        >
          <>
            {data.featuredContent.data?.map((item, index) => {
              return (
                <React.Fragment key={item.id}>
                  {index > 0 && <Spacer size={20} />}
                  <ContentCard
                    key={`${item.id}_${item.__typename}`}
                    typename={item.__typename}
                    // @ts-ignore
                    item={item}
                  />
                </React.Fragment>
              )
            })}
          </>
        </Box>
      </div>
    </Grow>
  )
}

export default FeaturedContent
